import { api } from '../../../../services/api';

export async function onUpdateObservacoes(data) {
  const response = await api.put('/site/v2/orcamento-crm/atualizar-observacoes-pedido', data);

  return response.data;
}

export async function onUpdateLigacao(data) {
  const response = await api.put('/site/v2/orcamento-crm/atualizar-validar-ligacao', data);

  return response.data;
}
